'use strict';

const meetingTime = function ($filter) {
  var translateFilter = $filter('translate');

  return input => {
    return translateFilter('MEETING_TIME.' + input.toUpperCase());
  };
};

meetingTime.$inject = [
  '$filter'
];

export default meetingTime;



// WEBPACK FOOTER //
// ./app/src/filters/meeting_time.js